export default "// Preset variables\n$body-font-family: 'Rubik', sans-serif;\n$btn-font-weight: 500;\n$border-radius-root: 0;\n$chip-line-height: 1.5;\n";